import React, { useEffect, useState } from "react";
import { useQuery, useStore } from "../stores/store";
import { useAuthContext } from "../stores/auth-store";
import { observer } from "mobx-react";
import { Text } from "@mantine/core";

export const PageContainer = observer((props: { children: React.ReactNode }) => {
  const auth = useAuthContext();
  const { authStore, store } = useStore();
  const [singnInAttempt, setSingInAttempt] = useState<number>(0);

  useEffect(() => {
    if (!auth.isLoading && !auth.isAuthenticated && singnInAttempt < 6) {
      auth.signinRedirect();
      setSingInAttempt(singnInAttempt + 1);
      return;
    }
    if (auth.isAuthenticated) {
      authStore.setUser(auth.user ?? null);
      store.initialiseAuth(authStore);
    }
  }, [auth.isLoading, auth.isAuthenticated]);
  const { isLoading } = useQuery({
    queryFn: async () => {
      return await store.initialise();
    },
    enabled: !!auth.isAuthenticated,
  });
  if (singnInAttempt === 6)
    return (
      <div
        style={{
          textAlign: "center",
          width: "100%",
          height: "100vh",
          marginTop: 20,
        }}
      >
        <Text>Authentication service not running contact development team </Text>
      </div>
    );
  if (isLoading) return <></>;
  return <React.Fragment>{props.children}</React.Fragment>;
});
